/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-first-prop-new-line */
import React from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
// import { useMediaQuery } from '@material-ui/core';
import {Card, Button, colors, Hidden} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withSnackbar } from 'notistack';
import './ordersfooter.css';
import { selectOrderCurrentOrder,selectOrderCurrentProduct} from '../../../../redux/order/order.selectors';
import { selectCurrentUser} from '../../../../redux/user/user.selectors';
import { selectLookupCurs } from 'redux/lookup/lookup.selectors';
import { t } from '../../../../i18n';


const useStyles = makeStyles((theme) => ({
  root: {},
  alignButton:{
    display:'flex',
    justifyContent: 'flex-end' 
  },
  container: {
    width:'100%',
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'space-between', 
    flexWrap:'wrap'
  },
  buton:{
    margin:'15px',
    background:colors.blueGrey[500],
    [theme.breakpoints.down('sm')]: {
      margin: '2px' ,
      width: '100px' ,
      height: '30px', 
      fontSize:'7px'
    }
    
  },
  fab: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  extendedIconGreen:{
    color:'yellow'
  },
  extendedIconRed:{
    color:'red'
  },
  extendedIconOrange:{
    color:'orange'
  }
}));

const ExpozorFooter = props => {
  const classes = useStyles();
  const { currentUser, currentProduct, currentOrder,history, enqueueSnackbar, curs} = props;
  const handleBack=()=>{
    let path = '/products';
    history.push(path);
  }
 
  return (
    <Card className={classes.container}> 
      <div> 
      
        <Button 
          className={classes.buton}
          color="primary"
          onClick={handleBack}
          size="small"
          startIcon={<ArrowBackIosIcon className={classes.extendedIconGrey}/>}
          variant="contained"
        >
        {t('ordersFooter.productsMenu')}
        </Button>
      </div> 
      
        
    </Card> 
  );
 
}

ExpozorFooter.propTypes = {
  className: PropTypes.string,
  currentOrder:PropTypes.object,
  currentProduct:PropTypes.object,
  currentUser:PropTypes.object,
  history:PropTypes.object
};

const mapStateToProps=state=>({
  currentOrder:selectOrderCurrentOrder(state),
  currentProduct:selectOrderCurrentProduct(state),
  currentUser:selectCurrentUser(state),
  curs:selectLookupCurs(state)
})

export default connect(mapStateToProps)(withRouter(withSnackbar(ExpozorFooter)));
